var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6\u7ED3\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4FEE\\u6539\\u5B9A\\u7A3F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875\\u5B9A\\u7A3F",
    transform: "translate(-1859, -4189)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-28",
    transform: "translate(1844, 4169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-107",
    transform: "translate(15, 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0462366,2.68649487 C4.20991103,2.27421595 5.45821632,2.71994134 6.85815192,4.06326074 C8.88929274,6.01749013 8.73413615,7.50722316 7.20725425,9.25087632 C6.84404677,9.6573533 6.69594276,9.82322048 6.57957531,9.98294444 C5.88842323,10.9133023 6.05768497,11.2313851 9.44644595,13.9849168 C12.2533697,16.2650786 12.9304167,16.6551737 13.3606236,16.4814568 C13.625628,16.3520821 13.8731567,16.1916047 14.0976174,16.0036501 C14.1646168,15.9551869 14.2316162,15.906041 14.2950894,15.8558713 C14.3832465,15.7910261 14.6794546,15.558266 14.6759283,15.5627028 C14.8310849,15.4401795 14.9509786,15.3528091 15.0708723,15.2695343 C16.5025445,14.2685292 17.8037441,14.4719384 19.6973598,16.3005729 C21.0655588,17.6186368 21.4781343,18.7977954 20.8998233,19.8325882 C20.476669,20.5916183 19.6585706,21.0967282 18.2621613,21.6571272 C15.4093958,22.8021569 9.96833629,21.0571385 5.30305973,16.7544892 C0.577836306,12.3965508 -1.08304447,7.22088043 0.697730035,4.82297339 C1.64277472,3.54961854 2.19287536,2.9871718 3.0462366,2.68649487 Z M11.3548387,0 C17.2339989,0 22,4.92486775 22,11 L20.5806452,11 C20.5806452,5.73488538 16.4501109,1.46666667 11.3548387,1.46666667 C11.2341935,1.46666667 11.1170968,1.47143333 11,1.47583333 L11,0.00916666667 C11.1170968,0.00513333333 11.2341935,0 11.3548387,0 Z M11,4.4 C14.6446572,4.4 17.6968246,7.25273231 18.0612903,11 L16.6277419,11 C16.2725798,8.0674551 13.8600842,5.86690214 11,5.86666667 L11,4.4 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.4b4517231f6c1e41d19e3ad138491344.svg";
export { ForwardRef as ReactComponent };